import { nextTick } from 'vue';

export function scrollToTop() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
}

const FOCUSABLE_CONTROLS = 'input:not([type="hidden"]):not([tabindex="-1"]), select, textarea';

function isRendered(element) {
    for (let node = element; node && node.nodeType === 1; node = node.parentElement) {
        if (node.hidden || window.getComputedStyle(node).display === 'none') {
            return false;
        }
    }
    return true;
}

/**
 * Focus the first field in `root` that can take it, e.g. a step just reached from the keyboard.
 * The page is already scrolling to the top, so this doesn't scroll.
 */
export function focusFirstField(root) {
    const control = Array.from(root?.querySelectorAll?.(FOCUSABLE_CONTROLS) ?? []).find(isRendered);
    control?.focus({ preventScroll: true });
}

/**
 * After a failed Next, bring the first field showing an error into view and focus it, so the
 * person lands on the problem instead of the top of the page (where, on a phone, the error is
 * often below the fold). LcField marks such fields with data-invalid="true"; DOM order is the
 * order they appear in. Falls back to the top when no rendered field is marked (e.g. a field
 * that failed without a message).
 */
export async function scrollToFirstInvalidField(root = document) {
    // let the error messages that validateForm() just set render first
    await nextTick();

    const field = Array.from(root.querySelectorAll('[data-invalid="true"]')).find(isRendered);
    if (!field) {
        scrollToTop();
        return;
    }

    field.scrollIntoView?.({ behavior: 'smooth', block: 'center' });

    // A composite field (the address) marks its failing parts; prefer the first of those.
    const controls = Array.from(field.querySelectorAll(FOCUSABLE_CONTROLS)).filter(isRendered);
    const control = controls.find(el => el.classList.contains('is-invalid')) ?? controls[0];
    control?.focus({ preventScroll: true });
}
